// generated from the massive list of postcodes in the ./generate-postcode-boundries folder
export interface postcodeProps {
  postcode: number;
  locality: string;
  State: string;
  long: number | string;
  lat: number | string;
  id: number;
  dc: string;
  type: string;
  status: string;
}

export const postcodes = [{
  "postcode": 6030,
  "locality": "RIDGEWOOD",
  "State": "WA",
  "long": 115.711684,
  "lat": -31.687341,
  "id": 9818,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6030,
  "locality": "TAMALA PARK",
  "State": "WA",
  "long": 115.711684,
  "lat": -31.687341,
  "id": 9819,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6031,
  "locality": "BANKSIA GROVE",
  "State": "WA",
  "long": 115.772138,
  "lat": -31.692538,
  "id": 9820,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6031,
  "locality": "CARRAMAR",
  "State": "WA",
  "long": 115.772138,
  "lat": -31.692538,
  "id": 9821,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6031,
  "locality": "NEERABUP",
  "State": "WA",
  "long": 115.772138,
  "lat": -31.692538,
  "id": 9822,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6032,
  "locality": "NOWERGUP",
  "State": "WA",
  "long": 115.74887,
  "lat": -31.643227,
  "id": 9823,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6033,
  "locality": "CARABOODA",
  "State": "WA",
  "long": 115.711357,
  "lat": -31.609115,
  "id": 9824,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6034,
  "locality": "EGLINTON",
  "State": "WA",
  "long": 115.663878,
  "lat": -31.585614,
  "id": 9825,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6035,
  "locality": "YANCHEP",
  "State": "WA",
  "long": 115.729901,
  "lat": -31.524716,
  "id": 9826,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6036,
  "locality": "BUTLER",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 9827,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6036,
  "locality": "JINDALEE",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 9828,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6037,
  "locality": "TWO ROCKS",
  "State": "WA",
  "long": 115.616105,
  "lat": -31.48847,
  "id": 9829,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6038,
  "locality": "ALKIMOS",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 9830,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6041,
  "locality": "CARABAN",
  "State": "WA",
  "long": 115.568551,
  "lat": -31.379673,
  "id": 9831,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6041,
  "locality": "GABBADAH",
  "State": "WA",
  "long": 115.568551,
  "lat": -31.379673,
  "id": 9832,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6041,
  "locality": "GUILDERTON",
  "State": "WA",
  "long": 115.568551,
  "lat": -31.379673,
  "id": 9833,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6041,
  "locality": "WILBINGA",
  "State": "WA",
  "long": 115.568551,
  "lat": -31.379673,
  "id": 9834,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6041,
  "locality": "WOODRIDGE",
  "State": "WA",
  "long": 115.568551,
  "lat": -31.379673,
  "id": 9835,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6042,
  "locality": "SEABIRD",
  "State": "WA",
  "long": 115.508625,
  "lat": -31.254414,
  "id": 9836,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6043,
  "locality": "BRETON BAY",
  "State": "WA",
  "long": 115.424522,
  "lat": -31.141763,
  "id": 9837,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6043,
  "locality": "LEDGE POINT",
  "State": "WA",
  "long": 115.424522,
  "lat": -31.141763,
  "id": 9838,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6044,
  "locality": "KARAKIN",
  "State": "WA",
  "long": 115.424656,
  "lat": -30.972846,
  "id": 9839,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6044,
  "locality": "LANCELIN",
  "State": "WA",
  "long": 115.424656,
  "lat": -30.972846,
  "id": 9840,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6044,
  "locality": "NILGEN",
  "State": "WA",
  "long": 115.424656,
  "lat": -30.972846,
  "id": 9841,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6044,
  "locality": "WEDGE ISLAND",
  "State": "WA",
  "long": 115.424656,
  "lat": -30.972846,
  "id": 9842,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6050,
  "locality": "COOLBINIA",
  "State": "WA",
  "long": 115.871864,
  "lat": -31.930574,
  "id": 9843,
  "dc": "BASSENDEAN DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6050,
  "locality": "MENORA",
  "State": "WA",
  "long": 115.871864,
  "lat": -31.930574,
  "id": 9844,
  "dc": "BASSENDEAN DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6050,
  "locality": "MOUNT LAWLEY",
  "State": "WA",
  "long": 115.871864,
  "lat": -31.930574,
  "id": 9845,
  "dc": "BASSENDEAN DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6051,
  "locality": "MAYLANDS",
  "State": "WA",
  "long": 115.899589,
  "lat": -31.938107,
  "id": 9846,
  "dc": "BASSENDEAN DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6052,
  "locality": "BEDFORD",
  "State": "WA",
  "long": 115.883976,
  "lat": -31.915463,
  "id": 9847,
  "dc": "BASSENDEAN DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6052,
  "locality": "INGLEWOOD",
  "State": "WA",
  "long": 115.883976,
  "lat": -31.915463,
  "id": 9848,
  "dc": "BASSENDEAN DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6053,
  "locality": "BAYSWATER",
  "State": "WA",
  "long": 115.914851,
  "lat": -31.920863,
  "id": 9849,
  "dc": "BASSENDEAN DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6054,
  "locality": "ASHFIELD",
  "State": "WA",
  "long": 115.942572,
  "lat": -31.901801,
  "id": 9850,
  "dc": "BASSENDEAN DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6054,
  "locality": "BASSENDEAN",
  "State": "WA",
  "long": 115.942572,
  "lat": -31.901801,
  "id": 9851,
  "dc": "BASSENDEAN DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6054,
  "locality": "BASSENDEAN DC",
  "State": "WA",
  "long": 115.942572,
  "lat": -31.901801,
  "id": 9852,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6054,
  "locality": "EDEN HILL",
  "State": "WA",
  "long": 115.942572,
  "lat": -31.901801,
  "id": 9853,
  "dc": "BASSENDEAN DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6054,
  "locality": "KIARA",
  "State": "WA",
  "long": 115.942572,
  "lat": -31.901801,
  "id": 9854,
  "dc": "BASSENDEAN DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6054,
  "locality": "LOCKRIDGE",
  "State": "WA",
  "long": 115.942572,
  "lat": -31.901801,
  "id": 9855,
  "dc": "BASSENDEAN DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6055,
  "locality": "CAVERSHAM",
  "State": "WA",
  "long": 115.980754,
  "lat": -31.842527,
  "id": 9856,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6055,
  "locality": "GUILDFORD",
  "State": "WA",
  "long": 115.980754,
  "lat": -31.842527,
  "id": 9857,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6055,
  "locality": "HAZELMERE",
  "State": "WA",
  "long": 115.980754,
  "lat": -31.842527,
  "id": 9858,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6055,
  "locality": "HENLEY BROOK",
  "State": "WA",
  "long": 115.980754,
  "lat": -31.842527,
  "id": 9859,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6055,
  "locality": "SOUTH GUILDFORD",
  "State": "WA",
  "long": 115.980754,
  "lat": -31.842527,
  "id": 9860,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6055,
  "locality": "WEST SWAN",
  "State": "WA",
  "long": 115.980754,
  "lat": -31.842527,
  "id": 9861,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6056,
  "locality": "BASKERVILLE",
  "State": "WA",
  "long": 116.0261,
  "lat": -31.838398,
  "id": 9862,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6056,
  "locality": "BELLEVUE",
  "State": "WA",
  "long": 116.0261,
  "lat": -31.838398,
  "id": 9863,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6056,
  "locality": "BOYA",
  "State": "WA",
  "long": 116.0261,
  "lat": -31.838398,
  "id": 9864,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6056,
  "locality": "GREENMOUNT",
  "State": "WA",
  "long": 116.0261,
  "lat": -31.838398,
  "id": 9865,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6056,
  "locality": "HELENA VALLEY",
  "State": "WA",
  "long": 116.0261,
  "lat": -31.838398,
  "id": 9866,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6056,
  "locality": "HERNE HILL",
  "State": "WA",
  "long": 116.0261,
  "lat": -31.838398,
  "id": 9867,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6056,
  "locality": "JANE BROOK",
  "State": "WA",
  "long": 116.0261,
  "lat": -31.838398,
  "id": 9868,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6056,
  "locality": "KOONGAMIA",
  "State": "WA",
  "long": 116.0261,
  "lat": -31.838398,
  "id": 9869,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6056,
  "locality": "MIDDLE SWAN",
  "State": "WA",
  "long": 116.0261,
  "lat": -31.838398,
  "id": 9870,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6056,
  "locality": "MIDLAND",
  "State": "WA",
  "long": 116.0261,
  "lat": -31.838398,
  "id": 9871,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6056,
  "locality": "MIDVALE",
  "State": "WA",
  "long": 116.0261,
  "lat": -31.838398,
  "id": 9872,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6056,
  "locality": "MILLENDON",
  "State": "WA",
  "long": 116.0261,
  "lat": -31.838398,
  "id": 9873,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6056,
  "locality": "RED HILL",
  "State": "WA",
  "long": 116.0261,
  "lat": -31.838398,
  "id": 9874,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6056,
  "locality": "STRATTON",
  "State": "WA",
  "long": 116.0261,
  "lat": -31.838398,
  "id": 9875,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6056,
  "locality": "SWAN VIEW",
  "State": "WA",
  "long": 116.0261,
  "lat": -31.838398,
  "id": 9876,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6056,
  "locality": "VIVEASH",
  "State": "WA",
  "long": 116.0261,
  "lat": -31.838398,
  "id": 9877,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6056,
  "locality": "WOODBRIDGE",
  "State": "WA",
  "long": 116.0261,
  "lat": -31.838398,
  "id": 9878,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6057,
  "locality": "HIGH WYCOMBE",
  "State": "WA",
  "long": 116.004245,
  "lat": -31.94994,
  "id": 9879,
  "dc": "WALLISTON DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6057,
  "locality": "MAIDA VALE",
  "State": "WA",
  "long": 116.004245,
  "lat": -31.94994,
  "id": 9880,
  "dc": "WALLISTON DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6058,
  "locality": "FORRESTFIELD",
  "State": "WA",
  "long": 116.006688,
  "lat": -31.985241,
  "id": 9881,
  "dc": "WELSHPOOL DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6059,
  "locality": "DIANELLA",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 9882,
  "dc": "MALAGA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6060,
  "locality": "DOG SWAMP",
  "State": "WA",
  "long": 115.840879,
  "lat": -31.903241,
  "id": 9883,
  "dc": "OSBORNE PARK DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6060,
  "locality": "JOONDANNA",
  "State": "WA",
  "long": 115.840879,
  "lat": -31.903241,
  "id": 9884,
  "dc": "OSBORNE PARK DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6060,
  "locality": "TUART HILL",
  "State": "WA",
  "long": 115.840879,
  "lat": -31.903241,
  "id": 9885,
  "dc": "OSBORNE PARK DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6060,
  "locality": "YOKINE",
  "State": "WA",
  "long": 115.840879,
  "lat": -31.903241,
  "id": 9886,
  "dc": "OSBORNE PARK DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6061,
  "locality": "BALGA",
  "State": "WA",
  "long": 115.843478,
  "lat": -31.864113,
  "id": 9887,
  "dc": "MALAGA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6061,
  "locality": "MIRRABOOKA",
  "State": "WA",
  "long": 115.843478,
  "lat": -31.864113,
  "id": 9888,
  "dc": "MALAGA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6061,
  "locality": "NOLLAMARA",
  "State": "WA",
  "long": 115.843478,
  "lat": -31.864113,
  "id": 9889,
  "dc": "MALAGA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6061,
  "locality": "WESTMINSTER",
  "State": "WA",
  "long": 115.843478,
  "lat": -31.864113,
  "id": 9890,
  "dc": "MALAGA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6000,
  "locality": "CITY DELIVERY CENTRE",
  "State": "WA",
  "long": 115.859912,
  "lat": -31.948762,
  "id": 10026,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6000,
  "locality": "PERTH",
  "State": "WA",
  "long": 115.859912,
  "lat": -31.948762,
  "id": 10027,
  "dc": "CITY DELIVERY CENTRE",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6000,
  "locality": "PERTH GPO",
  "State": "WA",
  "long": 115.859912,
  "lat": -31.948762,
  "id": 10028,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6001,
  "locality": "PERTH",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 10029,
  "dc": "CITY DELIVERY CENTRE",
  "type": "Post Office Boxes",
  "status": ""
}, {
  "postcode": 6003,
  "locality": "HIGHGATE",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 10030,
  "dc": "CITY DELIVERY CENTRE",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6003,
  "locality": "NORTHBRIDGE",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 10031,
  "dc": "CITY DELIVERY CENTRE",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6004,
  "locality": "EAST PERTH",
  "State": "WA",
  "long": 115.874601,
  "lat": -31.956931,
  "id": 10032,
  "dc": "CITY DELIVERY CENTRE",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6005,
  "locality": "KINGS PARK",
  "State": "WA",
  "long": 115.836896,
  "lat": -31.95707,
  "id": 10033,
  "dc": "WEST PERTH DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6005,
  "locality": "WEST PERTH",
  "State": "WA",
  "long": 115.836896,
  "lat": -31.95707,
  "id": 10034,
  "dc": "WEST PERTH DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6006,
  "locality": "NORTH PERTH",
  "State": "WA",
  "long": 115.852913,
  "lat": -31.92934,
  "id": 10035,
  "dc": "BASSENDEAN DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6007,
  "locality": "LEEDERVILLE",
  "State": "WA",
  "long": 115.834335,
  "lat": -31.935675,
  "id": 10036,
  "dc": "OSBORNE PARK DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6112,
  "locality": "PIARA WATERS",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 17679,
  "dc": "NULL",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6112,
  "locality": "HARRISDALE",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 17680,
  "dc": "NULL",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6112,
  "locality": "HAYNES",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 17681,
  "dc": "NULL",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6112,
  "locality": "HILBERT",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 17682,
  "dc": "NULL",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6111,
  "locality": "LESLEY",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 17683,
  "dc": "NULL",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6111,
  "locality": "CAMILLO",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 17684,
  "dc": "NULL",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6111,
  "locality": "ASHENDON",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 17685,
  "dc": "NULL",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6152,
  "locality": "KARAWARA",
  "State": "WA",
  "long": 115.870058,
  "lat": -32.008509,
  "id": 16169,
  "dc": "BENTLEY DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6152,
  "locality": "MANNING",
  "State": "WA",
  "long": 115.870058,
  "lat": -32.008509,
  "id": 16170,
  "dc": "BENTLEY DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6152,
  "locality": "SALTER POINT",
  "State": "WA",
  "long": 115.870058,
  "lat": -32.008509,
  "id": 16171,
  "dc": "BENTLEY DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6152,
  "locality": "WATERFORD",
  "State": "WA",
  "long": 115.870058,
  "lat": -32.008509,
  "id": 16172,
  "dc": "BENTLEY DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6153,
  "locality": "APPLECROSS",
  "State": "WA",
  "long": 115.837525,
  "lat": -32.024363,
  "id": 16173,
  "dc": "PALMYRA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6153,
  "locality": "APPLECROSS NORTH",
  "State": "WA",
  "long": 115.837525,
  "lat": -32.024363,
  "id": 16174,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6153,
  "locality": "ARDROSS",
  "State": "WA",
  "long": 115.837525,
  "lat": -32.024363,
  "id": 16175,
  "dc": "PALMYRA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6153,
  "locality": "BRENTWOOD",
  "State": "WA",
  "long": 115.837525,
  "lat": -32.024363,
  "id": 16176,
  "dc": "PALMYRA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6153,
  "locality": "CANNING BRIDGE APPLECROSS",
  "State": "WA",
  "long": 115.837525,
  "lat": -32.024363,
  "id": 16177,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6153,
  "locality": "MOUNT PLEASANT",
  "State": "WA",
  "long": 115.837525,
  "lat": -32.024363,
  "id": 16178,
  "dc": "PALMYRA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6154,
  "locality": "ALFRED COVE",
  "State": "WA",
  "long": 115.825994,
  "lat": -32.040061,
  "id": 16179,
  "dc": "PALMYRA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6154,
  "locality": "BOORAGOON",
  "State": "WA",
  "long": 115.825994,
  "lat": -32.040061,
  "id": 16180,
  "dc": "PALMYRA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6154,
  "locality": "MYAREE",
  "State": "WA",
  "long": 115.825994,
  "lat": -32.040061,
  "id": 16181,
  "dc": "PALMYRA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6155,
  "locality": "CANNING VALE",
  "State": "WA",
  "long": 115.890779,
  "lat": -32.061501,
  "id": 16182,
  "dc": "CANNING VALE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6155,
  "locality": "CANNING VALE DC",
  "State": "WA",
  "long": 115.890779,
  "lat": -32.061501,
  "id": 16183,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6155,
  "locality": "CANNING VALE SOUTH",
  "State": "WA",
  "long": 115.890779,
  "lat": -32.061501,
  "id": 16184,
  "dc": "CANNING VALE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6155,
  "locality": "WILLETTON",
  "State": "WA",
  "long": 115.890779,
  "lat": -32.061501,
  "id": 16185,
  "dc": "CANNING VALE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6156,
  "locality": "ATTADALE",
  "State": "WA",
  "long": 115.800233,
  "lat": -32.03954,
  "id": 16186,
  "dc": "PALMYRA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6156,
  "locality": "MELVILLE",
  "State": "WA",
  "long": 115.800233,
  "lat": -32.03954,
  "id": 16187,
  "dc": "PALMYRA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6156,
  "locality": "WILLAGEE",
  "State": "WA",
  "long": 115.800233,
  "lat": -32.03954,
  "id": 16188,
  "dc": "PALMYRA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6156,
  "locality": "WILLAGEE CENTRAL",
  "State": "WA",
  "long": 115.800233,
  "lat": -32.03954,
  "id": 16189,
  "dc": "PALMYRA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6157,
  "locality": "BICTON",
  "State": "WA",
  "long": 115.783732,
  "lat": -32.038228,
  "id": 16190,
  "dc": "PALMYRA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6157,
  "locality": "PALMYRA",
  "State": "WA",
  "long": 115.783732,
  "lat": -32.038228,
  "id": 16191,
  "dc": "PALMYRA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6157,
  "locality": "PALMYRA DC",
  "State": "WA",
  "long": 115.783732,
  "lat": -32.038228,
  "id": 16192,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6158,
  "locality": "EAST FREMANTLE",
  "State": "WA",
  "long": 115.766561,
  "lat": -32.038541,
  "id": 16193,
  "dc": "PALMYRA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6159,
  "locality": "NORTH FREMANTLE",
  "State": "WA",
  "long": 115.750311,
  "lat": -32.035224,
  "id": 16194,
  "dc": "PALMYRA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6160,
  "locality": "FREMANTLE",
  "State": "WA",
  "long": 115.754545,
  "lat": -32.054065,
  "id": 16195,
  "dc": "PALMYRA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6161,
  "locality": "ROTTNEST ISLAND",
  "State": "WA",
  "long": 115.520516,
  "lat": -32.005554,
  "id": 16196,
  "dc": "PALMYRA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6162,
  "locality": "BEACONSFIELD",
  "State": "WA",
  "long": 115.759022,
  "lat": -32.068768,
  "id": 16197,
  "dc": "PALMYRA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6162,
  "locality": "SOUTH FREMANTLE",
  "State": "WA",
  "long": 115.759022,
  "lat": -32.068768,
  "id": 16198,
  "dc": "PALMYRA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6162,
  "locality": "WHITE GUM VALLEY",
  "State": "WA",
  "long": 115.759022,
  "lat": -32.068768,
  "id": 16199,
  "dc": "PALMYRA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6163,
  "locality": "BIBRA LAKE",
  "State": "WA",
  "long": 115.798722,
  "lat": -32.084784,
  "id": 16200,
  "dc": "BIBRA LAKE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6163,
  "locality": "BIBRA LAKE DC",
  "State": "WA",
  "long": 115.798722,
  "lat": -32.084784,
  "id": 16201,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6163,
  "locality": "COOLBELLUP",
  "State": "WA",
  "long": 115.798722,
  "lat": -32.084784,
  "id": 16202,
  "dc": "BIBRA LAKE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6163,
  "locality": "HAMILTON HILL",
  "State": "WA",
  "long": 115.798722,
  "lat": -32.084784,
  "id": 16203,
  "dc": "BIBRA LAKE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6163,
  "locality": "HILTON",
  "State": "WA",
  "long": 115.798722,
  "lat": -32.084784,
  "id": 16204,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6163,
  "locality": "KARDINYA",
  "State": "WA",
  "long": 115.798722,
  "lat": -32.084784,
  "id": 16205,
  "dc": "BIBRA LAKE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6163,
  "locality": "NORTH LAKE",
  "State": "WA",
  "long": 115.798722,
  "lat": -32.084784,
  "id": 16206,
  "dc": "BIBRA LAKE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6163,
  "locality": "O'CONNOR",
  "State": "WA",
  "long": 115.798722,
  "lat": -32.084784,
  "id": 16207,
  "dc": "BIBRA LAKE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6163,
  "locality": "SAMSON",
  "State": "WA",
  "long": 115.798722,
  "lat": -32.084784,
  "id": 16208,
  "dc": "BIBRA LAKE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6163,
  "locality": "SPEARWOOD",
  "State": "WA",
  "long": 115.798722,
  "lat": -32.084784,
  "id": 16209,
  "dc": "BIBRA LAKE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6164,
  "locality": "ATWELL",
  "State": "WA",
  "long": 115.854584,
  "lat": -32.131993,
  "id": 16210,
  "dc": "BIBRA LAKE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6164,
  "locality": "AUBIN GROVE",
  "State": "WA",
  "long": 115.854584,
  "lat": -32.131993,
  "id": 16211,
  "dc": "BIBRA LAKE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6164,
  "locality": "BANJUP",
  "State": "WA",
  "long": 115.854584,
  "lat": -32.131993,
  "id": 16212,
  "dc": "BIBRA LAKE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6164,
  "locality": "BEELIAR",
  "State": "WA",
  "long": 115.854584,
  "lat": -32.131993,
  "id": 16213,
  "dc": "BIBRA LAKE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6164,
  "locality": "HAMMOND PARK",
  "State": "WA",
  "long": 115.854584,
  "lat": -32.131993,
  "id": 16214,
  "dc": "BIBRA LAKE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6164,
  "locality": "JANDAKOT",
  "State": "WA",
  "long": 115.854584,
  "lat": -32.131993,
  "id": 16215,
  "dc": "BIBRA LAKE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6164,
  "locality": "SOUTH LAKE",
  "State": "WA",
  "long": 115.854584,
  "lat": -32.131993,
  "id": 16216,
  "dc": "BIBRA LAKE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6164,
  "locality": "SUCCESS",
  "State": "WA",
  "long": 115.854584,
  "lat": -32.131993,
  "id": 16217,
  "dc": "BIBRA LAKE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6164,
  "locality": "YANGEBUP",
  "State": "WA",
  "long": 115.854584,
  "lat": -32.131993,
  "id": 16218,
  "dc": "BIBRA LAKE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6165,
  "locality": "HOPE VALLEY",
  "State": "WA",
  "long": 115.799431,
  "lat": -32.19598,
  "id": 16219,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6165,
  "locality": "NAVAL BASE",
  "State": "WA",
  "long": 115.799431,
  "lat": -32.19598,
  "id": 16220,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6166,
  "locality": "COOGEE",
  "State": "WA",
  "long": 115.790704,
  "lat": -32.158361,
  "id": 16221,
  "dc": "BIBRA LAKE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6166,
  "locality": "HENDERSON",
  "State": "WA",
  "long": 115.790704,
  "lat": -32.158361,
  "id": 16222,
  "dc": "BIBRA LAKE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6166,
  "locality": "MUNSTER",
  "State": "WA",
  "long": 115.790704,
  "lat": -32.158361,
  "id": 16223,
  "dc": "BIBRA LAKE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6166,
  "locality": "WATTLEUP",
  "State": "WA",
  "long": 115.790704,
  "lat": -32.158361,
  "id": 16224,
  "dc": "BIBRA LAKE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6167,
  "locality": "ANKETELL",
  "State": "WA",
  "long": 115.835308,
  "lat": -32.223657,
  "id": 16225,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6167,
  "locality": "BERTRAM",
  "State": "WA",
  "long": 115.835308,
  "lat": -32.223657,
  "id": 16226,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6167,
  "locality": "CALISTA",
  "State": "WA",
  "long": 115.835308,
  "lat": -32.223657,
  "id": 16227,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6167,
  "locality": "CASUARINA",
  "State": "WA",
  "long": 115.835308,
  "lat": -32.223657,
  "id": 16228,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6167,
  "locality": "KWINANA BEACH",
  "State": "WA",
  "long": 115.835308,
  "lat": -32.223657,
  "id": 16229,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6167,
  "locality": "KWINANA TOWN CENTRE",
  "State": "WA",
  "long": 115.835308,
  "lat": -32.223657,
  "id": 16230,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6167,
  "locality": "MANDOGALUP",
  "State": "WA",
  "long": 115.835308,
  "lat": -32.223657,
  "id": 16231,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6167,
  "locality": "MEDINA",
  "State": "WA",
  "long": 115.835308,
  "lat": -32.223657,
  "id": 16232,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6167,
  "locality": "ORELIA",
  "State": "WA",
  "long": 115.835308,
  "lat": -32.223657,
  "id": 16233,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6167,
  "locality": "PARMELIA",
  "State": "WA",
  "long": 115.835308,
  "lat": -32.223657,
  "id": 16234,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6167,
  "locality": "POSTANS",
  "State": "WA",
  "long": 115.835308,
  "lat": -32.223657,
  "id": 16235,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6167,
  "locality": "THE SPECTACLES",
  "State": "WA",
  "long": 115.835308,
  "lat": -32.223657,
  "id": 16236,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6167,
  "locality": "WANDI",
  "State": "WA",
  "long": 115.835308,
  "lat": -32.223657,
  "id": 16237,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6168,
  "locality": "COOLOONGUP",
  "State": "WA",
  "long": 115.75773,
  "lat": -32.281957,
  "id": 16238,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6168,
  "locality": "EAST ROCKINGHAM",
  "State": "WA",
  "long": 115.75773,
  "lat": -32.281957,
  "id": 16239,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6168,
  "locality": "GARDEN ISLAND",
  "State": "WA",
  "long": 115.75773,
  "lat": -32.281957,
  "id": 16240,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6168,
  "locality": "HILLMAN",
  "State": "WA",
  "long": 115.75773,
  "lat": -32.281957,
  "id": 16241,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6168,
  "locality": "PERON",
  "State": "WA",
  "long": 115.75773,
  "lat": -32.281957,
  "id": 16242,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6168,
  "locality": "ROCKINGHAM",
  "State": "WA",
  "long": 115.75773,
  "lat": -32.281957,
  "id": 16243,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6168,
  "locality": "ROCKINGHAM BEACH",
  "State": "WA",
  "long": 115.75773,
  "lat": -32.281957,
  "id": 16244,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6168,
  "locality": "ROCKINGHAM DC",
  "State": "WA",
  "long": 115.75773,
  "lat": -32.281957,
  "id": 16245,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6169,
  "locality": "SAFETY BAY",
  "State": "WA",
  "long": 115.763949,
  "lat": -32.338504,
  "id": 16246,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6169,
  "locality": "SHOALWATER",
  "State": "WA",
  "long": 115.763949,
  "lat": -32.338504,
  "id": 16247,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6169,
  "locality": "WAIKIKI",
  "State": "WA",
  "long": 115.763949,
  "lat": -32.338504,
  "id": 16248,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6169,
  "locality": "WARNBRO",
  "State": "WA",
  "long": 115.763949,
  "lat": -32.338504,
  "id": 16249,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6170,
  "locality": "LEDA",
  "State": "WA",
  "long": 115.835972,
  "lat": -32.265645,
  "id": 16250,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6170,
  "locality": "WELLARD",
  "State": "WA",
  "long": 115.835972,
  "lat": -32.265645,
  "id": 16251,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6171,
  "locality": "BALDIVIS",
  "State": "WA",
  "long": 115.833257,
  "lat": -32.328863,
  "id": 16252,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6172,
  "locality": "PORT KENNEDY",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16253,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6173,
  "locality": "SECRET HARBOUR",
  "State": "WA",
  "long": 115.757908,
  "lat": -32.407414,
  "id": 16254,
  "dc": "MANDURAH DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6174,
  "locality": "GOLDEN BAY",
  "State": "WA",
  "long": 115.760224,
  "lat": -32.42656,
  "id": 16255,
  "dc": "MANDURAH DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6175,
  "locality": "SINGLETON",
  "State": "WA",
  "long": 115.755289,
  "lat": -32.445896,
  "id": 16256,
  "dc": "MANDURAH DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6176,
  "locality": "KARNUP",
  "State": "WA",
  "long": 115.814323,
  "lat": -32.421669,
  "id": 16257,
  "dc": "ROCKINGHAM DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "BARRAGUP",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16274,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "BOUVARD",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16275,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "CLIFTON",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16276,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "COODANUP",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16277,
  "dc": "MANDURAH DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "DAWESVILLE",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16278,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "DUDLEY PARK",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16279,
  "dc": "MANDURAH DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "ERSKINE",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16280,
  "dc": "MANDURAH DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "FALCON",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16281,
  "dc": "MANDURAH DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "FURNISSDALE",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16282,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "GREENFIELDS",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16283,
  "dc": "MANDURAH DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "HALLS HEAD",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16284,
  "dc": "MANDURAH DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "HERRON",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16285,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "LAKELANDS",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16286,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "MADORA BAY",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16287,
  "dc": "MANDURAH DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "MANDURAH",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16288,
  "dc": "MANDURAH DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "MANDURAH DC",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16289,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "MANDURAH EAST",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16290,
  "dc": "MANDURAH DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "MANDURAH NORTH",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16291,
  "dc": "MANDURAH DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "MEADOW SPRINGS",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16292,
  "dc": "MANDURAH DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "PARKLANDS",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16293,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "SAN REMO",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16294,
  "dc": "MANDURAH DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "SILVER SANDS",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16295,
  "dc": "MANDURAH DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "STAKE HILL",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16296,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6210,
  "locality": "WANNANUP",
  "State": "WA",
  "long": 115.728286,
  "lat": -32.557981,
  "id": 16297,
  "dc": "MANDURAH DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6062,
  "locality": "EMBLETON",
  "State": "WA",
  "long": 115.89088,
  "lat": -31.886322,
  "id": 16313,
  "dc": "BASSENDEAN DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6062,
  "locality": "MORLEY",
  "State": "WA",
  "long": 115.89088,
  "lat": -31.886322,
  "id": 16314,
  "dc": "BASSENDEAN DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6062,
  "locality": "NORANDA",
  "State": "WA",
  "long": 115.89088,
  "lat": -31.886322,
  "id": 16315,
  "dc": "BASSENDEAN DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6063,
  "locality": "BEECHBORO",
  "State": "WA",
  "long": 115.937824,
  "lat": -31.866822,
  "id": 16316,
  "dc": "BASSENDEAN DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6064,
  "locality": "ALEXANDER HEIGHTS",
  "State": "WA",
  "long": 115.849098,
  "lat": -31.835333,
  "id": 16317,
  "dc": "MALAGA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6064,
  "locality": "GIRRAWHEEN",
  "State": "WA",
  "long": 115.849098,
  "lat": -31.835333,
  "id": 16318,
  "dc": "MALAGA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6064,
  "locality": "KOONDOOLA",
  "State": "WA",
  "long": 115.849098,
  "lat": -31.835333,
  "id": 16319,
  "dc": "MALAGA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6064,
  "locality": "MARANGAROO",
  "State": "WA",
  "long": 115.849098,
  "lat": -31.835333,
  "id": 16320,
  "dc": "MALAGA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6065,
  "locality": "ASHBY",
  "State": "WA",
  "long": 115.845329,
  "lat": -31.69444,
  "id": 16321,
  "dc": "WANGARA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6065,
  "locality": "DARCH",
  "State": "WA",
  "long": 115.845329,
  "lat": -31.69444,
  "id": 16322,
  "dc": "WANGARA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6065,
  "locality": "GNANGARA",
  "State": "WA",
  "long": 115.845329,
  "lat": -31.69444,
  "id": 16323,
  "dc": "WANGARA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6065,
  "locality": "HOCKING",
  "State": "WA",
  "long": 115.845329,
  "lat": -31.69444,
  "id": 16324,
  "dc": "WANGARA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6065,
  "locality": "JANDABUP",
  "State": "WA",
  "long": 115.845329,
  "lat": -31.69444,
  "id": 16325,
  "dc": "WANGARA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6065,
  "locality": "KINGSWAY",
  "State": "WA",
  "long": 115.845329,
  "lat": -31.69444,
  "id": 16326,
  "dc": "WANGARA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6065,
  "locality": "LANDSDALE",
  "State": "WA",
  "long": 115.845329,
  "lat": -31.69444,
  "id": 16327,
  "dc": "WANGARA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6065,
  "locality": "LEXIA",
  "State": "WA",
  "long": 115.845329,
  "lat": -31.69444,
  "id": 16328,
  "dc": "WANGARA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6065,
  "locality": "MADELEY",
  "State": "WA",
  "long": 115.845329,
  "lat": -31.69444,
  "id": 16329,
  "dc": "WANGARA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6065,
  "locality": "MARIGINIUP",
  "State": "WA",
  "long": 115.845329,
  "lat": -31.69444,
  "id": 16330,
  "dc": "WANGARA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6065,
  "locality": "MELALEUCA",
  "State": "WA",
  "long": 115.845329,
  "lat": -31.69444,
  "id": 16331,
  "dc": "WANGARA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6065,
  "locality": "PEARSALL",
  "State": "WA",
  "long": 115.845329,
  "lat": -31.69444,
  "id": 16332,
  "dc": "WANGARA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6065,
  "locality": "PINJAR",
  "State": "WA",
  "long": 115.845329,
  "lat": -31.69444,
  "id": 16333,
  "dc": "WANGARA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6065,
  "locality": "SINAGRA",
  "State": "WA",
  "long": 115.845329,
  "lat": -31.69444,
  "id": 16334,
  "dc": "WANGARA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6065,
  "locality": "TAPPING",
  "State": "WA",
  "long": 115.845329,
  "lat": -31.69444,
  "id": 16335,
  "dc": "WANGARA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6065,
  "locality": "WANGARA",
  "State": "WA",
  "long": 115.845329,
  "lat": -31.69444,
  "id": 16336,
  "dc": "WANGARA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6065,
  "locality": "WANGARA DC",
  "State": "WA",
  "long": 115.845329,
  "lat": -31.69444,
  "id": 16337,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6065,
  "locality": "WANNEROO",
  "State": "WA",
  "long": 115.845329,
  "lat": -31.69444,
  "id": 16338,
  "dc": "WANGARA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6066,
  "locality": "BALLAJURA",
  "State": "WA",
  "long": 115.896508,
  "lat": -31.84269,
  "id": 16339,
  "dc": "MALAGA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6067,
  "locality": "CULLACABARDEE",
  "State": "WA",
  "long": 115.899644,
  "lat": -31.816059,
  "id": 16340,
  "dc": "BASSENDEAN DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6068,
  "locality": "WHITEMAN",
  "State": "WA",
  "long": 115.941108,
  "lat": -31.826199,
  "id": 16341,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6069,
  "locality": "BELHUS",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16342,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6069,
  "locality": "BRIGADOON",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16343,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6069,
  "locality": "ELLENBROOK",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16344,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6069,
  "locality": "ELLENBROOK EAST",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16345,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6069,
  "locality": "THE VINES",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16346,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6069,
  "locality": "UPPER SWAN",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16347,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6070,
  "locality": "DARLINGTON",
  "State": "WA",
  "long": 116.079266,
  "lat": -31.929036,
  "id": 16348,
  "dc": "MIDLAND DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6071,
  "locality": "GLEN FORREST",
  "State": "WA",
  "long": 116.100432,
  "lat": -31.889087,
  "id": 16349,
  "dc": "MUNDARING DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6071,
  "locality": "HOVEA",
  "State": "WA",
  "long": 116.100432,
  "lat": -31.889087,
  "id": 16350,
  "dc": "MUNDARING DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6072,
  "locality": "MAHOGANY CREEK",
  "State": "WA",
  "long": 116.132045,
  "lat": -31.907828,
  "id": 16351,
  "dc": "MUNDARING DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6073,
  "locality": "MUNDARING",
  "State": "WA",
  "long": 116.28143,
  "lat": -31.949349,
  "id": 16352,
  "dc": "MUNDARING DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6073,
  "locality": "MUNDARING DC",
  "State": "WA",
  "long": 116.28143,
  "lat": -31.949349,
  "id": 16353,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6073,
  "locality": "MUNDARING WEIR",
  "State": "WA",
  "long": 116.28143,
  "lat": -31.949349,
  "id": 16354,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6074,
  "locality": "SAWYERS VALLEY",
  "State": "WA",
  "long": 116.20454,
  "lat": -31.896593,
  "id": 16355,
  "dc": "MUNDARING DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6076,
  "locality": "BICKLEY",
  "State": "WA",
  "long": 116.208263,
  "lat": -32.108961,
  "id": 16356,
  "dc": "WALLISTON DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6076,
  "locality": "CARMEL",
  "State": "WA",
  "long": 116.208263,
  "lat": -32.108961,
  "id": 16357,
  "dc": "WALLISTON DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6076,
  "locality": "GOOSEBERRY HILL",
  "State": "WA",
  "long": 116.208263,
  "lat": -32.108961,
  "id": 16358,
  "dc": "WALLISTON DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6076,
  "locality": "HACKETTS GULLY",
  "State": "WA",
  "long": 116.208263,
  "lat": -32.108961,
  "id": 16359,
  "dc": "WALLISTON DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6076,
  "locality": "KALAMUNDA",
  "State": "WA",
  "long": 116.208263,
  "lat": -32.108961,
  "id": 16360,
  "dc": "WALLISTON DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6076,
  "locality": "LESMURDIE",
  "State": "WA",
  "long": 116.208263,
  "lat": -32.108961,
  "id": 16361,
  "dc": "WALLISTON DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6076,
  "locality": "PAULLS VALLEY",
  "State": "WA",
  "long": 116.208263,
  "lat": -32.108961,
  "id": 16362,
  "dc": "WALLISTON DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6076,
  "locality": "PICKERING BROOK",
  "State": "WA",
  "long": 116.208263,
  "lat": -32.108961,
  "id": 16363,
  "dc": "WALLISTON DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6076,
  "locality": "PIESSE BROOK",
  "State": "WA",
  "long": 116.208263,
  "lat": -32.108961,
  "id": 16364,
  "dc": "WALLISTON DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6076,
  "locality": "RESERVOIR",
  "State": "WA",
  "long": 116.208263,
  "lat": -32.108961,
  "id": 16365,
  "dc": "WALLISTON DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6076,
  "locality": "WALLISTON",
  "State": "WA",
  "long": 116.208263,
  "lat": -32.108961,
  "id": 16366,
  "dc": "WALLISTON DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6076,
  "locality": "WALLISTON DC",
  "State": "WA",
  "long": 116.208263,
  "lat": -32.108961,
  "id": 16367,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6081,
  "locality": "PARKERVILLE",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16368,
  "dc": "MUNDARING DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6081,
  "locality": "STONEVILLE",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16369,
  "dc": "MUNDARING DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6082,
  "locality": "BAILUP",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16370,
  "dc": "MUNDARING DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6082,
  "locality": "MOUNT HELENA",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16371,
  "dc": "MUNDARING DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6083,
  "locality": "GIDGEGANNUP",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16372,
  "dc": "MUNDARING DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6083,
  "locality": "MORANGUP",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16373,
  "dc": "MUNDARING DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6084,
  "locality": "AVON VALLEY NATIONAL PARK",
  "State": "WA",
  "long": 116.072828,
  "lat": -31.622021,
  "id": 16374,
  "dc": "BULLSBROOK LPO",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6084,
  "locality": "BULLSBROOK",
  "State": "WA",
  "long": 116.072828,
  "lat": -31.622021,
  "id": 16375,
  "dc": "BULLSBROOK LPO",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6084,
  "locality": "CHITTERING",
  "State": "WA",
  "long": 116.072828,
  "lat": -31.622021,
  "id": 16376,
  "dc": "BULLSBROOK LPO",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6084,
  "locality": "LOWER CHITTERING",
  "State": "WA",
  "long": 116.072828,
  "lat": -31.622021,
  "id": 16377,
  "dc": "BULLSBROOK LPO",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6084,
  "locality": "WALYUNGA NATIONAL PARK",
  "State": "WA",
  "long": 116.072828,
  "lat": -31.622021,
  "id": 16378,
  "dc": "BULLSBROOK LPO",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6090,
  "locality": "MALAGA",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16379,
  "dc": "MALAGA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6100,
  "locality": "BURSWOOD",
  "State": "WA",
  "long": 115.896029,
  "lat": -31.971725,
  "id": 16380,
  "dc": "BENTLEY DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6100,
  "locality": "LATHLAIN",
  "State": "WA",
  "long": 115.896029,
  "lat": -31.971725,
  "id": 16381,
  "dc": "BENTLEY DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6100,
  "locality": "VICTORIA PARK",
  "State": "WA",
  "long": 115.896029,
  "lat": -31.971725,
  "id": 16382,
  "dc": "BENTLEY DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6101,
  "locality": "CARLISLE",
  "State": "WA",
  "long": 115.908576,
  "lat": -31.985247,
  "id": 16383,
  "dc": "BENTLEY DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6101,
  "locality": "CARLISLE NORTH",
  "State": "WA",
  "long": 115.908576,
  "lat": -31.985247,
  "id": 16384,
  "dc": "BENTLEY DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6101,
  "locality": "CARLISLE SOUTH",
  "State": "WA",
  "long": 115.908576,
  "lat": -31.985247,
  "id": 16385,
  "dc": "BENTLEY DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6101,
  "locality": "EAST VICTORIA PARK",
  "State": "WA",
  "long": 115.908576,
  "lat": -31.985247,
  "id": 16386,
  "dc": "BENTLEY DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6102,
  "locality": "BENTLEY",
  "State": "WA",
  "long": 115.904425,
  "lat": -32.005644,
  "id": 16387,
  "dc": "BENTLEY DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6102,
  "locality": "BENTLEY DC",
  "State": "WA",
  "long": 115.904425,
  "lat": -32.005644,
  "id": 16388,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6102,
  "locality": "ST JAMES",
  "State": "WA",
  "long": 115.904425,
  "lat": -32.005644,
  "id": 16389,
  "dc": "BENTLEY DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6103,
  "locality": "RIVERVALE",
  "State": "WA",
  "long": 115.913458,
  "lat": -31.960364,
  "id": 16390,
  "dc": "WELSHPOOL DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6104,
  "locality": "ASCOT",
  "State": "WA",
  "long": 115.977633,
  "lat": -31.965498,
  "id": 16391,
  "dc": "WELSHPOOL DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6104,
  "locality": "BELMONT",
  "State": "WA",
  "long": 115.977633,
  "lat": -31.965498,
  "id": 16392,
  "dc": "WELSHPOOL DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6104,
  "locality": "REDCLIFFE",
  "State": "WA",
  "long": 115.977633,
  "lat": -31.965498,
  "id": 16393,
  "dc": "WELSHPOOL DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6105,
  "locality": "CLOVERDALE",
  "State": "WA",
  "long": 115.963293,
  "lat": -31.95388,
  "id": 16394,
  "dc": "WELSHPOOL DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6105,
  "locality": "KEWDALE",
  "State": "WA",
  "long": 115.963293,
  "lat": -31.95388,
  "id": 16395,
  "dc": "WELSHPOOL DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6105,
  "locality": "PERTH AIRPORT",
  "State": "WA",
  "long": 115.963293,
  "lat": -31.95388,
  "id": 16396,
  "dc": "WELSHPOOL DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6106,
  "locality": "WELSHPOOL",
  "State": "WA",
  "long": 115.945564,
  "lat": -31.992082,
  "id": 16397,
  "dc": "WELSHPOOL DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6106,
  "locality": "WELSHPOOL DC",
  "State": "WA",
  "long": 115.945564,
  "lat": -31.992082,
  "id": 16398,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6107,
  "locality": "BECKENHAM",
  "State": "WA",
  "long": 115.967142,
  "lat": -32.017663,
  "id": 16399,
  "dc": "WELSHPOOL DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6107,
  "locality": "CANNINGTON",
  "State": "WA",
  "long": 115.967142,
  "lat": -32.017663,
  "id": 16400,
  "dc": "WELSHPOOL DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6107,
  "locality": "EAST CANNINGTON",
  "State": "WA",
  "long": 115.967142,
  "lat": -32.017663,
  "id": 16401,
  "dc": "WELSHPOOL DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6107,
  "locality": "KENWICK",
  "State": "WA",
  "long": 115.967142,
  "lat": -32.017663,
  "id": 16402,
  "dc": "WELSHPOOL DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6107,
  "locality": "QUEENS PARK",
  "State": "WA",
  "long": 115.967142,
  "lat": -32.017663,
  "id": 16403,
  "dc": "WELSHPOOL DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6107,
  "locality": "WATTLE GROVE",
  "State": "WA",
  "long": 115.967142,
  "lat": -32.017663,
  "id": 16404,
  "dc": "WELSHPOOL DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6107,
  "locality": "WILSON",
  "State": "WA",
  "long": 115.967142,
  "lat": -32.017663,
  "id": 16405,
  "dc": "WELSHPOOL DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6108,
  "locality": "THORNLIE",
  "State": "WA",
  "long": 115.953584,
  "lat": -32.06089,
  "id": 16406,
  "dc": "CANNING VALE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6109,
  "locality": "MADDINGTON",
  "State": "WA",
  "long": 116.013165,
  "lat": -32.039897,
  "id": 16407,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6109,
  "locality": "ORANGE GROVE",
  "State": "WA",
  "long": 116.013165,
  "lat": -32.039897,
  "id": 16408,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6110,
  "locality": "GOSNELLS",
  "State": "WA",
  "long": 116.008603,
  "lat": -32.078535,
  "id": 16409,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6110,
  "locality": "HUNTINGDALE",
  "State": "WA",
  "long": 116.008603,
  "lat": -32.078535,
  "id": 16410,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6110,
  "locality": "MARTIN",
  "State": "WA",
  "long": 116.008603,
  "lat": -32.078535,
  "id": 16411,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6110,
  "locality": "SOUTHERN RIVER",
  "State": "WA",
  "long": 116.008603,
  "lat": -32.078535,
  "id": 16412,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6111,
  "locality": "CANNING MILLS",
  "State": "WA",
  "long": 116.095955,
  "lat": -32.09788,
  "id": 16413,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6111,
  "locality": "CHAMPION LAKES",
  "State": "WA",
  "long": 116.095955,
  "lat": -32.09788,
  "id": 16414,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6111,
  "locality": "KARRAGULLEN",
  "State": "WA",
  "long": 116.095955,
  "lat": -32.09788,
  "id": 16415,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6111,
  "locality": "KELMSCOTT",
  "State": "WA",
  "long": 116.095955,
  "lat": -32.09788,
  "id": 16416,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6111,
  "locality": "KELMSCOTT DC",
  "State": "WA",
  "long": 116.095955,
  "lat": -32.09788,
  "id": 16417,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6111,
  "locality": "ROLEYSTONE",
  "State": "WA",
  "long": 116.095955,
  "lat": -32.09788,
  "id": 16418,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6111,
  "locality": "WESTFIELD",
  "State": "WA",
  "long": 116.095955,
  "lat": -32.09788,
  "id": 16419,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6112,
  "locality": "ARMADALE",
  "State": "WA",
  "long": 115.997934,
  "lat": -32.158675,
  "id": 16420,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6112,
  "locality": "BEDFORDALE",
  "State": "WA",
  "long": 115.997934,
  "lat": -32.158675,
  "id": 16421,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6112,
  "locality": "BROOKDALE",
  "State": "WA",
  "long": 115.997934,
  "lat": -32.158675,
  "id": 16422,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6112,
  "locality": "FORRESTDALE",
  "State": "WA",
  "long": 115.997934,
  "lat": -32.158675,
  "id": 16423,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6112,
  "locality": "MOUNT NASURA",
  "State": "WA",
  "long": 115.997934,
  "lat": -32.158675,
  "id": 16424,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6112,
  "locality": "MOUNT RICHON",
  "State": "WA",
  "long": 115.997934,
  "lat": -32.158675,
  "id": 16425,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6112,
  "locality": "SEVILLE GROVE",
  "State": "WA",
  "long": 115.997934,
  "lat": -32.158675,
  "id": 16426,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6112,
  "locality": "WUNGONG",
  "State": "WA",
  "long": 115.997934,
  "lat": -32.158675,
  "id": 16427,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6121,
  "locality": "OAKFORD",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16428,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6121,
  "locality": "OLDBURY",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16429,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6122,
  "locality": "BYFORD",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16430,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6122,
  "locality": "CARDUP",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16431,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6122,
  "locality": "DARLING DOWNS",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16432,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6122,
  "locality": "KARRAKUP",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16433,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6123,
  "locality": "MUNDIJONG",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16434,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6123,
  "locality": "WHITBY",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16435,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6124,
  "locality": "JARRAHDALE",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16436,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6125,
  "locality": "HOPELAND",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16437,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6125,
  "locality": "MARDELLA",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16438,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6125,
  "locality": "SERPENTINE",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16439,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6126,
  "locality": "KEYSBROOK",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16440,
  "dc": "KELMSCOTT DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6147,
  "locality": "LANGFORD",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16441,
  "dc": "CANNING VALE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6147,
  "locality": "LYNWOOD",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16442,
  "dc": "CANNING VALE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6147,
  "locality": "PARKWOOD",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16443,
  "dc": "CANNING VALE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6148,
  "locality": "FERNDALE",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16444,
  "dc": "CANNING VALE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6148,
  "locality": "RIVERTON",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16445,
  "dc": "CANNING VALE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6148,
  "locality": "ROSSMOYNE",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16446,
  "dc": "CANNING VALE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6148,
  "locality": "SHELLEY",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16447,
  "dc": "CANNING VALE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6149,
  "locality": "BULL CREEK",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16448,
  "dc": "CANNING VALE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6149,
  "locality": "LEEMING",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 16449,
  "dc": "CANNING VALE DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6150,
  "locality": "BATEMAN",
  "State": "WA",
  "long": 115.833608,
  "lat": -32.061682,
  "id": 16450,
  "dc": "PALMYRA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6150,
  "locality": "MURDOCH",
  "State": "WA",
  "long": 115.833608,
  "lat": -32.061682,
  "id": 16451,
  "dc": "PALMYRA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6150,
  "locality": "WINTHROP",
  "State": "WA",
  "long": 115.833608,
  "lat": -32.061682,
  "id": 16452,
  "dc": "PALMYRA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6151,
  "locality": "KENSINGTON",
  "State": "WA",
  "long": 115.869482,
  "lat": -31.982199,
  "id": 16453,
  "dc": "BENTLEY DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6151,
  "locality": "SOUTH PERTH",
  "State": "WA",
  "long": 115.869482,
  "lat": -31.982199,
  "id": 16454,
  "dc": "BENTLEY DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6151,
  "locality": "SOUTH PERTH ANGELO ST",
  "State": "WA",
  "long": 115.869482,
  "lat": -31.982199,
  "id": 16455,
  "dc": "BENTLEY DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6152,
  "locality": "COMO",
  "State": "WA",
  "long": 115.870058,
  "lat": -32.008509,
  "id": 16456,
  "dc": "BENTLEY DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6007,
  "locality": "WEST LEEDERVILLE",
  "State": "WA",
  "long": 115.834335,
  "lat": -31.935675,
  "id": 16457,
  "dc": "OSBORNE PARK DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6008,
  "locality": "DAGLISH",
  "State": "WA",
  "long": 115.811432,
  "lat": -31.956599,
  "id": 16458,
  "dc": "NEDLANDS DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6008,
  "locality": "SHENTON PARK",
  "State": "WA",
  "long": 115.811432,
  "lat": -31.956599,
  "id": 16459,
  "dc": "NEDLANDS DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6008,
  "locality": "SUBIACO",
  "State": "WA",
  "long": 115.811432,
  "lat": -31.956599,
  "id": 16460,
  "dc": "NEDLANDS DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6008,
  "locality": "SUBIACO EAST",
  "State": "WA",
  "long": 115.811432,
  "lat": -31.956599,
  "id": 16461,
  "dc": "NEDLANDS DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6009,
  "locality": "BROADWAY NEDLANDS",
  "State": "WA",
  "long": 115.804692,
  "lat": -31.985791,
  "id": 16462,
  "dc": "NEDLANDS DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6009,
  "locality": "CRAWLEY",
  "State": "WA",
  "long": 115.804692,
  "lat": -31.985791,
  "id": 16463,
  "dc": "NEDLANDS DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6009,
  "locality": "DALKEITH",
  "State": "WA",
  "long": 115.804692,
  "lat": -31.985791,
  "id": 16464,
  "dc": "NEDLANDS DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6009,
  "locality": "NEDLANDS",
  "State": "WA",
  "long": 115.804692,
  "lat": -31.985791,
  "id": 16465,
  "dc": "NEDLANDS DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6009,
  "locality": "NEDLANDS DC",
  "State": "WA",
  "long": 115.804692,
  "lat": -31.985791,
  "id": 16466,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6010,
  "locality": "CLAREMONT",
  "State": "WA",
  "long": 115.77639,
  "lat": -31.971647,
  "id": 16467,
  "dc": "NEDLANDS DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6010,
  "locality": "CLAREMONT NORTH",
  "State": "WA",
  "long": 115.77639,
  "lat": -31.971647,
  "id": 16468,
  "dc": "NEDLANDS DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6010,
  "locality": "KARRAKATTA",
  "State": "WA",
  "long": 115.77639,
  "lat": -31.971647,
  "id": 16469,
  "dc": "NEDLANDS DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6010,
  "locality": "MOUNT CLAREMONT",
  "State": "WA",
  "long": 115.77639,
  "lat": -31.971647,
  "id": 16470,
  "dc": "NEDLANDS DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6010,
  "locality": "SWANBOURNE",
  "State": "WA",
  "long": 115.77639,
  "lat": -31.971647,
  "id": 16471,
  "dc": "NEDLANDS DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6011,
  "locality": "COTTESLOE",
  "State": "WA",
  "long": 115.757646,
  "lat": -31.996371,
  "id": 16472,
  "dc": "NEDLANDS DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6011,
  "locality": "PEPPERMINT GROVE",
  "State": "WA",
  "long": 115.757646,
  "lat": -31.996371,
  "id": 16473,
  "dc": "NEDLANDS DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6012,
  "locality": "MOSMAN PARK",
  "State": "WA",
  "long": 115.763404,
  "lat": -32.015976,
  "id": 16474,
  "dc": "NEDLANDS DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6014,
  "locality": "FLOREAT",
  "State": "WA",
  "long": 115.808169,
  "lat": -31.936389,
  "id": 16475,
  "dc": "OSBORNE PARK DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6014,
  "locality": "FLOREAT FORUM",
  "State": "WA",
  "long": 115.808169,
  "lat": -31.936389,
  "id": 16476,
  "dc": "OSBORNE PARK DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6014,
  "locality": "JOLIMONT",
  "State": "WA",
  "long": 115.808169,
  "lat": -31.936389,
  "id": 16477,
  "dc": "OSBORNE PARK DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6014,
  "locality": "WEMBLEY",
  "State": "WA",
  "long": 115.808169,
  "lat": -31.936389,
  "id": 16478,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6015,
  "locality": "CITY BEACH",
  "State": "WA",
  "long": 115.764683,
  "lat": -31.938454,
  "id": 16479,
  "dc": "GWELUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6016,
  "locality": "GLENDALOUGH",
  "State": "WA",
  "long": 115.831181,
  "lat": -31.921222,
  "id": 16480,
  "dc": "OSBORNE PARK DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6016,
  "locality": "MOUNT HAWTHORN",
  "State": "WA",
  "long": 115.831181,
  "lat": -31.921222,
  "id": 16481,
  "dc": "OSBORNE PARK DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6017,
  "locality": "HERDSMAN",
  "State": "WA",
  "long": 115.814562,
  "lat": -31.908357,
  "id": 16482,
  "dc": "OSBORNE PARK DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6017,
  "locality": "OSBORNE PARK",
  "State": "WA",
  "long": 115.814562,
  "lat": -31.908357,
  "id": 16483,
  "dc": "OSBORNE PARK DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6017,
  "locality": "OSBORNE PARK DC",
  "State": "WA",
  "long": 115.814562,
  "lat": -31.908357,
  "id": 16484,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6018,
  "locality": "CHURCHLANDS",
  "State": "WA",
  "long": 115.786821,
  "lat": -31.891957,
  "id": 16485,
  "dc": "GWELUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6018,
  "locality": "DOUBLEVIEW",
  "State": "WA",
  "long": 115.786821,
  "lat": -31.891957,
  "id": 16486,
  "dc": "GWELUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6018,
  "locality": "GWELUP",
  "State": "WA",
  "long": 115.786821,
  "lat": -31.891957,
  "id": 16487,
  "dc": "GWELUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6018,
  "locality": "GWELUP DC",
  "State": "WA",
  "long": 115.786821,
  "lat": -31.891957,
  "id": 16488,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6018,
  "locality": "INNALOO",
  "State": "WA",
  "long": 115.786821,
  "lat": -31.891957,
  "id": 16489,
  "dc": "GWELUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6018,
  "locality": "KARRINYUP",
  "State": "WA",
  "long": 115.786821,
  "lat": -31.891957,
  "id": 16490,
  "dc": "GWELUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6018,
  "locality": "WOODLANDS",
  "State": "WA",
  "long": 115.786821,
  "lat": -31.891957,
  "id": 16491,
  "dc": "GWELUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6019,
  "locality": "SCARBOROUGH",
  "State": "WA",
  "long": 115.769183,
  "lat": -31.90733,
  "id": 16492,
  "dc": "GWELUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6019,
  "locality": "WEMBLEY DOWNS",
  "State": "WA",
  "long": 115.769183,
  "lat": -31.90733,
  "id": 16493,
  "dc": "GWELUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6020,
  "locality": "CARINE",
  "State": "WA",
  "long": 115.765396,
  "lat": -31.852698,
  "id": 16494,
  "dc": "GWELUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6020,
  "locality": "MARMION",
  "State": "WA",
  "long": 115.765396,
  "lat": -31.852698,
  "id": 16495,
  "dc": "GWELUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6020,
  "locality": "NORTH BEACH",
  "State": "WA",
  "long": 115.765396,
  "lat": -31.852698,
  "id": 16496,
  "dc": "GWELUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6020,
  "locality": "SORRENTO",
  "State": "WA",
  "long": 115.765396,
  "lat": -31.852698,
  "id": 16497,
  "dc": "GWELUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6020,
  "locality": "WATERMANS BAY",
  "State": "WA",
  "long": 115.765396,
  "lat": -31.852698,
  "id": 16498,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6021,
  "locality": "BALCATTA",
  "State": "WA",
  "long": 115.811933,
  "lat": -31.871671,
  "id": 16499,
  "dc": "OSBORNE PARK DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6021,
  "locality": "STIRLING",
  "State": "WA",
  "long": 115.811933,
  "lat": -31.871671,
  "id": 16500,
  "dc": "OSBORNE PARK DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6022,
  "locality": "HAMERSLEY",
  "State": "WA",
  "long": 115.80924,
  "lat": -31.851998,
  "id": 16501,
  "dc": "WANGARA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6023,
  "locality": "DUNCRAIG",
  "State": "WA",
  "long": 115.774028,
  "lat": -31.834469,
  "id": 16502,
  "dc": "WANGARA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6023,
  "locality": "GLENGARRY",
  "State": "WA",
  "long": 115.774028,
  "lat": -31.834469,
  "id": 16503,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6024,
  "locality": "GREENWOOD",
  "State": "WA",
  "long": 115.803068,
  "lat": -31.83489,
  "id": 16504,
  "dc": "WANGARA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6024,
  "locality": "WARWICK",
  "State": "WA",
  "long": 115.803068,
  "lat": -31.83489,
  "id": 16505,
  "dc": "WANGARA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6025,
  "locality": "CRAIGIE",
  "State": "WA",
  "long": 115.754405,
  "lat": -31.79583,
  "id": 16506,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6025,
  "locality": "HILLARYS",
  "State": "WA",
  "long": 115.754405,
  "lat": -31.79583,
  "id": 16507,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6025,
  "locality": "KALLAROO",
  "State": "WA",
  "long": 115.754405,
  "lat": -31.79583,
  "id": 16508,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6025,
  "locality": "PADBURY",
  "State": "WA",
  "long": 115.754405,
  "lat": -31.79583,
  "id": 16509,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6026,
  "locality": "KINGSLEY",
  "State": "WA",
  "long": 115.799832,
  "lat": -31.801707,
  "id": 16510,
  "dc": "WANGARA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6026,
  "locality": "WOODVALE",
  "State": "WA",
  "long": 115.799832,
  "lat": -31.801707,
  "id": 16511,
  "dc": "WANGARA DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6027,
  "locality": "BELDON",
  "State": "WA",
  "long": 115.756405,
  "lat": -31.763347,
  "id": 16512,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6027,
  "locality": "CONNOLLY",
  "State": "WA",
  "long": 115.756405,
  "lat": -31.763347,
  "id": 16513,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6027,
  "locality": "EDGEWATER",
  "State": "WA",
  "long": 115.756405,
  "lat": -31.763347,
  "id": 16514,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6027,
  "locality": "HEATHRIDGE",
  "State": "WA",
  "long": 115.756405,
  "lat": -31.763347,
  "id": 16515,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6027,
  "locality": "JOONDALUP",
  "State": "WA",
  "long": 115.756405,
  "lat": -31.763347,
  "id": 16516,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6027,
  "locality": "JOONDALUP DC",
  "State": "WA",
  "long": 115.756405,
  "lat": -31.763347,
  "id": 16517,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6027,
  "locality": "MULLALOO",
  "State": "WA",
  "long": 115.756405,
  "lat": -31.763347,
  "id": 16518,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6027,
  "locality": "OCEAN REEF",
  "State": "WA",
  "long": 115.756405,
  "lat": -31.763347,
  "id": 16519,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6028,
  "locality": "BURNS BEACH",
  "State": "WA",
  "long": 115.747655,
  "lat": -31.733717,
  "id": 16520,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6028,
  "locality": "CURRAMBINE",
  "State": "WA",
  "long": 115.747655,
  "lat": -31.733717,
  "id": 16521,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6028,
  "locality": "ILUKA",
  "State": "WA",
  "long": 115.747655,
  "lat": -31.733717,
  "id": 16522,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6028,
  "locality": "KINROSS",
  "State": "WA",
  "long": 115.747655,
  "lat": -31.733717,
  "id": 16523,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6029,
  "locality": "TRIGG",
  "State": "WA",
  "long": 115.755689,
  "lat": -31.876897,
  "id": 16524,
  "dc": "GWELUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6030,
  "locality": "CLARKSON",
  "State": "WA",
  "long": 115.711684,
  "lat": -31.687341,
  "id": 16525,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6030,
  "locality": "MERRIWA",
  "State": "WA",
  "long": 115.711684,
  "lat": -31.687341,
  "id": 16526,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6030,
  "locality": "MINDARIE",
  "State": "WA",
  "long": 115.711684,
  "lat": -31.687341,
  "id": 16527,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6030,
  "locality": "QUINNS ROCKS",
  "State": "WA",
  "long": 115.711684,
  "lat": -31.687341,
  "id": 16528,
  "dc": "JOONDALUP DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6077,
  "locality": "GNANGARA",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 42,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6077,
  "locality": "JANDABUP",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 43,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6078,
  "locality": "MARIGINIUP",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 44,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6078,
  "locality": "PINJAR",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 45,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6079,
  "locality": "LEXIA",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 46,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6079,
  "locality": "MELALEUCA",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 47,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6180,
  "locality": "LAKELANDS",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 48,
  "dc": "MANDURAH DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6180,
  "locality": "PARKLANDS",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 49,
  "dc": "MANDURAH DC",
  "type": "Delivery Area",
  "status": ""
}, {
  "postcode": 6181,
  "locality": "STAKE HILL",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 50,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}, {
  "postcode": 6182,
  "locality": "KERALUP",
  "State": "WA",
  "long": "NULL",
  "lat": "NULL",
  "id": 51,
  "dc": "NULL",
  "type": "NULL",
  "status": ""
}]